import { ReactNode, createContext, useContext, useMemo } from 'react'
import { PageRead, Website } from '@/api/dashboard'

interface HubSettingsContextType {
  website?: Website
  pages: {
    loading: boolean
    primal: PageRead[]
    others: PageRead[]
  }
}

const defaultContext: HubSettingsContextType = {
  website: undefined,
  pages: {
    loading: false,
    primal: [],
    others: [],
  },
}

const HubSettingsContext = createContext<HubSettingsContextType>(defaultContext)

interface HubSettingsProviderProps {
  children: ReactNode
  website?: Website
  pages: {
    loading: boolean
    primal: PageRead[]
    others: PageRead[]
  }
}

export const HubSettingsProvider = ({ children, website, pages }: HubSettingsProviderProps) => {
  const contextValue = useMemo(
    () => ({
      website,
      pages,
    }),
    [website, pages.loading, pages.primal, pages.others],
  )

  return <HubSettingsContext.Provider value={contextValue}>{children}</HubSettingsContext.Provider>
}

export const useHubSettings = () => useContext(HubSettingsContext)
